/**
 * database64 to 2 binary
 *
 * @param  {[String]} data dataURL format: “data:image/png;base64,****”
 * @param  {[String]} mime [description]
 * @return {[blob]}      [description]
 */
export default function(data, mime) {
    data = data.split(',')[1]
    data = window.atob(data)
    var ia = new Uint8Array(data.length)
    for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i)
    }
    // canvas.toDataURL 返回的默认格式就是 image/png
    return new Blob([ia], {
        type: mime
    })
}